import {useState, useCallback} from 'react';

export function useToastTimeout(timeoutDelayMs: number | null) {
  const [isVisible, setToast] = useState(false);

  const run = useCallback(
    function runTimer() {
      setToast(true);

      if (timeoutDelayMs === null) {
        setToast(false);
        return;
      }

      const timeout = setTimeout(() => {
        setToast(false);
      }, timeoutDelayMs);

      return () => {
        clearTimeout(timeout);
        setToast(false);
      };
    },
    [timeoutDelayMs],
  );

  return [isVisible, run] as const;
}
